import { type FunctionComponent, Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { Popover, type PopoverProps } from '@trello/nachos/popover';
import { useLazyComponent } from '@trello/use-lazy-component';

export interface CardCoverPopoverProps {
  pop: () => void;
  popoverProps: PopoverProps<HTMLButtonElement, HTMLElement>;
  push: (screen: number) => void;
}

export const CardCoverPopover: FunctionComponent<CardCoverPopoverProps> = ({
  pop,
  popoverProps,
  push,
}) => {
  const CardCoverPopoverContent = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-cover-popover-content" */ './CardCoverPopoverContent'
      ),
    { namedImport: 'CardCoverPopoverContent' },
  );

  return (
    <Popover {...popoverProps} size="medium">
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <CardCoverPopoverContent push={push} pop={pop} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </Popover>
  );
};
